export default __webpack_public_path__ + "static/media/Lust_for_life.9f216bda.jpeg";